import React, { Component } from 'react';
import { APP_URL_API } from '../../../setup/configs';
import Input from '../../../ui/input/Input';
import axios from 'axios';
import Header from '../../common/Header';
import Modal from '../../../ui/modal/Modal';
import AuthService from '../../auth/AuthService';
import withAuth from '../../auth/withAuth';
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import { Editor } from 'react-draft-wysiwyg';
import '../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

class Mail extends Component {
	constructor(props) {
        super(props);
        this.state = {
            subject: '',
            editorState: EditorState.createEmpty(),
            sendToAll: false,
            showModal: false,
            organizations: '',
            mailSent: false
        }
    }

	onChange = (e) => {
	    const name= e.target.name;
	    const value= e.target.value;

	    this.setState({
	      [name]: value,
          mailSent: false
	    });
	}

    fixUnderlineTag = (markup) => {
        let fixedMarkup = markup;
        fixedMarkup = fixedMarkup.replace("<ins>", "<u>");
        fixedMarkup = fixedMarkup.replace("</ins>", "</u>");
        return fixedMarkup;
    }

	onHandleSend = () => {
		if(this.state.subject==="") {
			this.setState({
		        showModal: true
		      });
			return false;
		}
		const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};

        const data = {};
        const rawContentState = convertToRaw(this.state.editorState.getCurrentContent());
        let markup = draftToHtml(
          rawContentState
        );
        markup = this.fixUnderlineTag(markup);
        data.subject = this.state.subject;
        data.content = markup;
        data.send_to_all = this.state.sendToAll==='on' ? 1 : 0;
        if(this.state.organizations!=="") data.organizations = this.state.organizations;

        const url = APP_URL_API + 'mails';
        	this.serverRequest =
            axios
                .post(url, data, {headers: config})
                .then(function(result) {
                    this.setState({
                        mailSent: true
                    })
                }.bind(this))
	}

	onEditorStateChange: Function = (editorState) => {
	    this.setState({
	      editorState,
          mailSent: false
	    });
	};

	render() {
		return(
			<div>
				<Header user={this.props.user} history={this.props.history}>
	              {this.props.user.type === 'admin' && <nav className="navigation">
	                <ul className="navigation__list">
	                  <li className="navigation__listitem"><a href="/admin/organizations/">Oversigt</a></li>
	                  <li className="navigation__listitem"><a href="/admin/organization/create">Opret</a></li>
	                  <li className="navigation__listitem active"><a href="/admin/organizations/settings">Indstillinger</a></li>
	                </ul>
	              </nav>}
	            </Header>

                <ul className="navigation__list navigation__list--settings">
                    <li className="navigation__listitem--small"><a href="/admin/organizations/settings/">Årsoversigt</a></li>
                    <li className="navigation__listitem--small"><a href="/admin/organizations/settings/alert/">Tilsynsmeddelelse</a></li>
					<li className="navigation__listitem--small"><a href="/admin/organizations/settings/alert-info/">Informationsmeddelelse</a></li>
                    <li className="navigation__listitem--small"><u>Mailafsendelse</u></li>
					<li className="navigation__listitem--small"><a href="/admin/organizations/settings/administrators/">Brugerstyring</a></li>
                </ul>

	            <div className="content-wrapper">
	                    <div style={{margin: '2em 0'}}>
		                    <h3 className="list-header">Mailafsendelse</h3>
	                    </div>
	                    <div style={{margin: '2em 0'}}>
	                    	<Input placeholder="Emne:" type="text" name="subject" value={this.state.subject} onChange={this.onChange} />
	                    </div>
	                    <div style={{margin: '2em 0'}} className="editor">
	                    	<div>Tekstfelt:</div>
	                    	<Editor editorState={this.state.editorState} onEditorStateChange={this.onEditorStateChange} />
	                    </div>
	                    <div style={{margin: '2em 0'}}>
                            <label><input type="checkbox" name="sendToAll" onChange={this.onChange} checked={this.state.sendToAll} />
                            Send til alle CVR numre</label>
                        </div>
                        <div style={{margin: '2em 0'}}>
                            <Input placeholder="Send til følgende CVR numre" type="text" name="organizations" value={this.state.organizations} onChange={this.onChange} />
                        </div>
                        <div style={{margin: '2em 0'}}>
	                    	<button className="button ocean" onClick={this.onHandleSend} disabled={this.state.dataSaved}>Send</button>
	                    </div>
                        {this.state.mailSent && <div className="savedMessage">Mailen er sendt</div>}
	            </div>

	            <Modal visible={this.state.showModal}>
	            	<p>Emne skal udfyldes</p>
	            	<div style={{marginTop: '3em', textAlign: 'right', minWidth: '400px'}}>
	                	<button type="button" className="button" onClick={() => this.setState({showModal: false})}>Ok</button>
	            	</div>
	          	</Modal>

	        </div>
	    )
	}
}

export default withAuth(Mail);


// WEBPACK FOOTER //
// ./src/modules/admin/organization/Mail.js